import {createFeatureSelector, createSelector, MemoizedSelector} from "@ngrx/store";
import {
  CustomFindStoresState,
  CustomStateWithStoreFinder,
  CustomStoresState,
  STORE_FINDER_FEATURE
} from "./custom-store-finder.states";
import {StateUtils} from "@spartacus/core";

export const getStoreFinderState: MemoizedSelector<
  CustomStateWithStoreFinder,
  CustomStoresState
  > = createFeatureSelector<CustomStoresState>(STORE_FINDER_FEATURE);

export const getFindStoresState: MemoizedSelector<
  CustomStateWithStoreFinder,
  StateUtils.LoaderState<CustomFindStoresState>
  > = createSelector(
  getStoreFinderState,
  (storesState: CustomStoresState) => storesState.findStores
);

export const getFindStoresEntities: MemoizedSelector<
  CustomStateWithStoreFinder,
  CustomFindStoresState
  > = createSelector(getFindStoresState, (state) =>
  StateUtils.loaderValueSelector(state)
);

export const getStoresLoading: MemoizedSelector<
  CustomStateWithStoreFinder,
  boolean
  > = createSelector(getFindStoresState, (state) =>
  StateUtils.loaderLoadingSelector(state)
);

export const getStoresSuccess: MemoizedSelector<
  CustomStateWithStoreFinder,
  boolean
  > = createSelector(getFindStoresState, (state) =>
  StateUtils.loaderSuccessSelector(state)
);
